/*
 * @Author: 戴旭
 * @Date: 2023-02-17 16:07:58
 * @LastEditTime: 2023-02-17 16:10:15
 * @LastEditors: 戴旭
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\cloud-visit\cloud-visit\module\dataManageRouter.js
 * 数据管理
 */

const dataManageRouter = [

  // 医生数据管理
  {
    path: '/outsideSystem/doctor-data',
    name: 'outsideSystemDoctorData',
    component: () =>
      import(
        /*webpackChunkName:"outsideSystemData" */
        '@/views/cloud-visit/cloud-visit/data-manage/doc-data-manage/Page.vue'
        ),
    meta: {
      SecondaryMenu: '数据管理', //二级菜单
      title: '医生数据管理'
    }
  },


  // 医生数据管理 解绑日志
  // meta_type 1-店员 2-医生
  {
    path: '/outsideSystem/unbind-log/:meta_type',
    name: 'outsideSystemUnbindLog',
    component: () =>
      import(
        /*webpackChunkName:"outsideSystemLog" */
        '@/views/cloud-visit/cloud-visit/data-manage/doc-data-manage/Log.vue'
        ),
    meta: {
      SecondaryMenu: '数据管理', //二级菜单
      2: {
        title: '解绑日志',
        breadcrumb: [{
          title: '医生数据管理',
          name: 'outsideSystemDoctorData',
        }, ],
      },
      1: {
        title: '解绑日志',
        breadcrumb: [{
          title: '药店数据管理',
          name: 'outsideSystemDrugstoreData',
        }, ],
      },
    },
  },


  // 医生数据管理 通用码医生导入
  {
    path: '/outsideSystem/common-code-import',
    name: 'outsideSystemCommonImport',
    component: () =>
      import(
        /*webpackChunkName:"outsideSystemimport" */
        '@/views/cloud-visit/cloud-visit/data-manage/doc-data-manage/DocImport.vue'
        ),
    meta: {
      SecondaryMenu: '数据管理', //二级菜单
      title: '通用码医生',
      breadcrumb: [{
        title: '医生数据管理',
        name: 'outsideSystemDoctorData',
      }, ],
    },
  },


  // 医生数据管理 病例列表
  {
    path: '/outsideSystem/cases-collected/list/:meta_type',
    name: 'outsideSystemCasesCollectedList',
    component: () =>
      import(
        /*webpackChunkName:"outsideSystemCasesCollectedList" */
        '@/views/cloud-visit/cloud-visit/data-manage/doc-data-manage/cases/Page.vue'
        ),
    meta: {
      SecondaryMenu: '数据管理', //二级菜单
      1: {
        title: '病例收集',
        breadcrumb: [{
          title: '药店数据管理',
          name: 'outsideSystemDrugstoreData',
        }, ],
      },
      5: {
        title: '病例收集',
        breadcrumb: [{
          title: '医生数据管理',
          name: 'outsideSystemDoctorData',
        }, ],
      },
    },
  },
  // 医生数据管理 病例列表 病例详情
  {
    path: '/outsideSystem/cases-collected/detail/:meta_type/:medical_record_id',
    name: 'outsideSystemCasesCollectedDetail',
    component: () =>
      import(
        /*webpackChunkName:"outsideSystemCasesCollectedDetail" */
        '@/views/cloud-visit/cloud-visit/data-manage/doc-data-manage/cases/Details.vue'
        ),
    meta: {
      SecondaryMenu: '数据管理', //二级菜单
      1: {
        title: '病例详情',
        breadcrumb: [{
          title: '药店数据管理',
          name: 'outsideSystemDrugstoreData',
        },
          {
            title: '病例收集',
            name: 'outsideSystemCasesCollectedList',
          },
        ],
      },
      5: {
        title: '病例详情',
        breadcrumb: [{
          title: '医生数据管理',
          name: 'outsideSystemDoctorData',
        },
          {
            title: '病例收集',
            name: 'outsideSystemCasesCollectedList',
          },
        ],
      },
    },
  },


  // 药店数据管理
  {
    path: '/outsideSystem/drugstore-data',
    name: 'outsideSystemDrugstoreData',
    component: () =>
      import(
        /*webpackChunkName:"outsideSystemData" */
        // '@/views/outsideSystem/DrugstoreData' //待删除
        '@/views/cloud-visit/cloud-visit/data-manage/pharmacy-data-manage/Page.vue'
        ),
    meta: {
      SecondaryMenu: '数据管理', //二级菜单
      title: '药店数据管理',
    },
  },

];

export default dataManageRouter;